<div class="navbar-top">
    <div class="logo">
        <button mat-icon-button class="toggle-sidebar-folded max-lg:hidden" (click)="toggleSidebarFolded()">
            <mat-icon>menu</mat-icon>
        </button>
        <span class="logo-text">{{ tenantName }}</span>
    </div>

    <div class="buttons">
        <button mat-icon-button class="toggle-sidebar-opened lg:hidden" (click)="toggleSidebarOpened()">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
</div>

<div class="navbar-scroll-container h-full" fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{ suppressScrollX: true }">
    <div class="navbar-content h-full flex flex-col">
        @if (navigation) {
        <fuse-navigation layout="vertical"></fuse-navigation>
        } @else {
        <div class="space-y-3 mx-2">
            <div class="h-12 bg-primary-100 rounded-full animate-pulse"></div>
            <div class="h-12 bg-primary-100 rounded-full animate-pulse"></div>
            <div class="h-12 bg-primary-100 rounded-full animate-pulse"></div>
            <div class="h-12 bg-primary-100 rounded-full animate-pulse"></div>
        </div>
        }
    </div>
</div>